import React from 'react'
import { connect } from 'react-redux'
import { EditionType } from '@graphics/gfx-common/dist/constants'
import { PackType, IEditionMetadata } from '../../types/pack'
import { mapEditionToProps } from '../../selectors/pack'
import { CombinedTitle, H1 } from '../../components'

export interface IPackTitle {
  editionId?: string
  edition?: IEditionMetadata
  pack: PackType
  isLightGroup?: boolean
}

const getEditionTypeLabel = (edition: IEditionMetadata): string =>
  edition && edition.editionType === EditionType.GraphicFolder
    ? 'Folder'
    : 'File'

export const PackTitleComponent = ({
  editionId,
  edition,
  pack,
  isLightGroup = false,
}: IPackTitle) => {
  if (isLightGroup) {
    return (
      <CombinedTitle
        first={`${pack.title || 'Untitled'} Lite`}
        second="Graphic"
      />
    )
  } else if (editionId === 'overall-pack') {
    return <CombinedTitle first={pack.title || 'Untitled'} second="Pack" />
  } else if (editionId === 'add-datafile') {
    return <CombinedTitle first="Untitled " second="Datafile" />
  } else if (edition) {
    return (
      <CombinedTitle
        first={edition.editionName}
        second={getEditionTypeLabel(edition)}
      />
    )
  } else {
    return <H1>Loading...</H1>
  }
}

export const PackTitle = connect(mapEditionToProps)(PackTitleComponent)
